import { SIGNUP_URL } from '../config';

function Hero() {
  return (
    <section class="relative text-center pt-[calc(64px+clamp(4rem,10vh,8rem))] pb-[clamp(4rem,8vh,6rem)]">
      {/* Glow background */}
      <div class="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[radial-gradient(ellipse_at_center,var(--accent-glow)_0%,transparent_70%)] pointer-events-none z-0" />

      <div class="relative z-10 container">
        <img
          src="/logo.png"
          alt="TanrenAI"
          class="w-[100px] h-[100px] mx-auto mb-8 drop-shadow-[0_0_30px_var(--accent-glow)] animate-forge-glow"
        />
        <h1 class="font-display text-[clamp(2.5rem,6vw,4.5rem)] font-extrabold tracking-[-0.03em] leading-[1.08] mb-5">
          Unlimited tokens.<br />
          <em class="not-italic bg-gradient-to-br from-accent to-[oklch(62%_0.20_40)] bg-clip-text text-transparent">
            Pay for the GPU.
          </em>
        </h1>
        <p class="text-[clamp(1rem,2vw,1.25rem)] text-muted max-w-[600px] mx-auto mb-10 leading-relaxed">
          Chat, agent mode, and persistent memory on real GPU hardware. No message caps,
          no rate limits, no per-token billing — you pay only for the GPU time you use.
          Or self-host the open-source binary on your own machine.
        </p>

        <div class="flex gap-4 justify-center flex-wrap">
          <a href={SIGNUP_URL} target="_blank" rel="noopener" class="btn-primary">
            <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
            Get Started
          </a>
          <a
            href="#features"
            class="btn-secondary"
            onClick={(e: Event) => {
              e.preventDefault();
              document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            How It Works
          </a>
        </div>

        <div class="mt-10 inline-flex items-center gap-3 px-[1.5em] py-[0.75em] font-mono text-[0.85rem] text-muted rounded-radius-sm glass">
          <code class="text-fg">
            <span class="text-muted">$</span> tanrenai <span class="text-accent">--local run</span> Qwen3-8B-Q4_K_M
          </code>
          <button
            class="bg-transparent border-0 cursor-pointer text-muted p-1 transition-colors hover:text-accent"
            onClick={() => navigator.clipboard.writeText('tanrenai --local run Qwen3-8B-Q4_K_M')}
            title="Copy"
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
